import { render, staticRenderFns } from "./MemberItem.vue?vue&type=template&id=4e63d127&scoped=true&"
import script from "./MemberItem.vue?vue&type=script&lang=js&"
export * from "./MemberItem.vue?vue&type=script&lang=js&"
import style0 from "./MemberItem.vue?vue&type=style&index=0&id=4e63d127&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e63d127",
  null
  
)

export default component.exports